import { httpClient } from '../config/httpClient';

export const path = {
  clearCache: '/cache/clear',
};

export const clearSearchCache = async () => {
  await httpClient.post(path.clearCache);
};
